import { parseISO } from 'date-fns';
import type { MedicalGroupDetailDataObject, MedicalGroupListDataObject } from './services';

export type MedicalGroupDetail = {
  city?: string;
  country?: string;
  description?: string;
  identifiers?: {
    npi?: string;
  };
  legalName?: string;
  state?: string;
  street?: string;
  zip?: string;
} & MedicalGroupList;

export type MedicalGroupList = {
  createdAt: Date;
  id: string;
  identifiers?: {
    npi?: string;
  };
  name: string;
  updatedAt: Date;
};

export const createMedicalGroupList = (data: MedicalGroupListDataObject): MedicalGroupList => ({
  createdAt: parseISO(data.createdAt),
  id: data._id,
  identifiers: data.identifiers,
  name: data.name,
  updatedAt: parseISO(data.updatedAt),
});

export const createMedicalGroupDetail = (data: MedicalGroupDetailDataObject): MedicalGroupDetail => ({
  ...createMedicalGroupList(data),
  city: data.city,
  country: data.country,
  description: data.description,
  legalName: data.legalName,
  state: data.state,
  street: data.address,
  zip: data.postalCode,
});
